module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq279-6723f6b00fc303664aec27e037ed3a3f.jpg";